export default __webpack_public_path__ + "static/media/previous.743fb7d8.svg";